// extracted by mini-css-extract-plugin
export default {"sellerCard":"SellerDetailsCard_sellerCard__W2Zq8","sellerCardGradient":"SellerDetailsCard_sellerCardGradient__1Ii0N"};